
import React, { useEffect } from 'react';
import { Container, Row,Col} from 'react-bootstrap';
import faviconicon from "../assets/images/404favicon.svg";
export default function NotFoundPage() {


  useEffect(() => {
    document.title = "The page you were looking for doesn't exist (404)";
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.href = faviconicon;
  }, []);
  
  return (
    <>
     <Container fluid className="bg-light">
      <Row className="d-flex align-items-center justify-content-center vh-100">
        <Col className="text-center">
            <h1 className="display-1 fw-bold">404</h1>
            <p className="fs-3"><span className="text-danger">Opps!</span> Page not found.</p>
            <p className="lead">You may have mistyped the address or the page may have moved.</p>
        </Col>
    </Row> 
    </Container> 
    </>
  )
}
